import React, { Component } from "react";
import { Grid, Paper, Typography, CircularProgress, Button } from "@material-ui/core";
// import ColorPicker from "material-ui-color-picker";
import styles from "../../styles";
import { withStyles } from "@material-ui/core/styles";

import _ from "lodash";

import { connect } from "react-redux";
import { pushMessage } from "../../../../redux/actions/commonActions";
import { updateChatbotColorSettings } from "../../../../redux/actions/chatbotActions";
import Iframe from "../ChatBotIframe/";
import { ColorPicker } from "material-ui-color";

const initialValuesState = {
  primary: "blue",
  secondary: "#b59a6d",
  iconCircle: "#b59a6d",
  iconSvg: "#000000",
  bubble: "#000000",
  bubbleText: "#b59a6d",
  userMessage: "#555",
  userMessageText: "#fff",
  botMessage: "#ddd",
  botMessageText: "#000"
};

class ColorForm extends Component {
  constructor(props) {
    super(props);
    const valid = _.isEmpty(props.data) ? false : true;
    const values = { ...initialValuesState };
    if (!_.isEmpty(props.data)) {
      values["primary"] = _.get(props.data, "config.color.primary", "#ffffff");
      values["secondary"] = _.get(props.data, "config.color.secondary", "#b59a6d");
      values["iconCircle"] = _.get(props.data, "config.color.iconCircle", "#b59a6d");
      values["iconSvg"] = _.get(props.data, "config.color.iconSvg", "#000000");
      values["bubble"] = _.get(props.data, "config.color.bubble", "#000000");
      values["bubbleText"] = _.get(props.data, "config.color.bubbleText", "#b59a6d");
      values["userMessage"] = _.get(props.data, "config.color.userMessage", "#555");
      values["userMessageText"] = _.get(props.data, "config.color.userMessageText", "#ffffff");
      values["botMessage"] = _.get(props.data, "config.color.botMessage", "#ddd");
      values["botMessageText"] = _.get(props.data, "config.color.botMessageText", "#000");
    }

    this.state = {
      isLoading: false,
      values: {
        ...values
      },
      touched: {
        primary: valid,
        secondary: valid,
        iconCircle: valid,
        iconSvg: valid,
        bubble: valid,
        bubbleText: valid,
        userMessage: valid,
        userMessageText: valid,
        botMessage: valid,
        botMessageText: valid
      },
      formValid: valid,
      changed: false,
      botUrlClosed: "",
      botUrlOpened: "",
      botUrl: "https://s3.amazonaws.com/responsum.ai.assistant/blank_bot_settings.html",
      delay: null
    };
  }

  handleInput = (field, value) => {
    const newState = { ...this.state };

    newState.values[field] = value;
    console.log(typeof value === "string" ? value : "#" + value.hex);
    newState.changed = true;
    newState.touched[field] = true;
    if (field == "iconCircle" || field == "iconSvg") {
      newState.botUrlClosed = this.generateBotUrl(false);
    } else {
      newState.botUrlOpened = this.generateBotUrl(true);
    }
    this.props.updateSetting(newState.values);
    this.setState(newState);
  };

  componentDidMount() {
    const newState = { ...this.state };
    newState.botUrlClosed = this.generateBotUrl(false);
    newState.botUrlOpened = this.generateBotUrl(true);
    this.setState(newState);
  }

  handleSave = async e => {
    e.preventDefault();
    this.setState({ isLoading: true });
    var config = {};
    for (let x in this.state.values) {
      let color = this.state.values[x];
      config[x] = typeof color === "string" ? color : "#" + color.hex;
    }

    await this.props
      .updateChatbotColorSettings({
        GUID: _.get(this.props, "data.GUID"),
        ...config
      })
      .then(() => {
        this.setState({ isLoading: false });
      });
  };

  serialize = obj => {
    var str = [];
    for (var p in obj)
      if (typeof obj[p] === "object") {
        for (var j in obj[p]) {
          if (Array.isArray(obj[p])) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p][j]));
          } else {
            str.push(encodeURIComponent(p + "-" + j) + "=" + encodeURIComponent(obj[p][j]));
          }
        }
      } else {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  };

  generateBotUrl = open => {
    var config = {
      botName: _.get(this.props.data, "config.botName", "Responsum Assistant"),
      welcomeMessage: _.get(this.props.data, "config.welcomeMessage", "Your welcome message"),
      examplePhrases: _.get(this.props.data, "config.examplePhrases", [
        "What is my order status?",
        "What is the quality of your wood?",
        "How long do custom orders take?"
      ]),
      chatImage: _.get(
        this.props.data,
        "config.chatImage",
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRj3qEbbzfeN4UYpN0YN9QFdYZpfALUaoL9afDihRrLvjBtEKW3"
      ),
      chatImageLink: _.get(this.props.data, "config.chatImageLink", "https://www.responsum.ai/"),
      botID: _.get(this.props.data, "config.botID", "07853fb3-8d53-47f3-9312-49c23044f7c0"),
      voiceEnabled: _.get(this.props.data, "config.voiceEnabled", true),
      mainChatDiv: "chatbox-main",
      bubbles: _.get(this.props.data, "config.bubbles", false),
      color: {},
      position: {
        desktopBottom: "120",
        desktopRight: "120",
        mobileBottom: "0",
        mobileRight: "0"
      },
      opened: open,
      transition: false
    };

    for (var x in this.state.values) {
      let color = this.state.values[x];
      config["color"][x] = typeof color === "string" ? color : "#" + color.hex;
    }

    return this.state.botUrl + "?" + this.serialize(config);
  };

  render() {
    const { classes, administrator } = this.props;
    const { isLoading, values, changed, botUrlClosed, botUrlOpened } = this.state;
    return (
      <React.Fragment>
        <Paper className={classes.colorRoot} elevation={0}>
          <form onSubmit={this.handleSave}>
            <Grid container spacing={2}>
              <Grid item xs={12} className={classes.colorLabelRoot}>
                <Typography variant="body1" component="span" className={classes.colorLabel}>
                  Primary:
                </Typography>
                <ColorPicker value={values.primary} onChange={color => this.handleInput("primary", color)} />
              </Grid>

              <Grid item xs={12} className={classes.colorLabelRoot}>
                <Typography variant="body1" component="span" className={classes.colorLabel}>
                  Assistant Name:
                </Typography>
                <ColorPicker value={values.secondary} onChange={color => this.handleInput("secondary", color)} />
              </Grid>

              <Grid item xs={12} className={classes.colorLabelRoot}>
                <Typography variant="body1" component="span" className={classes.colorLabel}>
                  Icon Circle:
                </Typography>
                <ColorPicker value={values.iconCircle} onChange={color => this.handleInput("iconCircle", color)} />
              </Grid>

              <Grid item xs={12} className={classes.colorLabelRoot}>
                <Typography variant="body1" component="span" className={classes.colorLabel}>
                  Icon Chat Bubble:
                </Typography>
                <ColorPicker value={values.iconSvg} onChange={color => this.handleInput("iconSvg", color)} />
              </Grid>

              <Grid item xs={12} className={classes.colorLabelRoot}>
                <Typography variant="body1" component="span" className={classes.colorLabel}>
                  Smart Bubble:
                </Typography>
                <ColorPicker value={values.bubble} onChange={color => this.handleInput("bubble", color)} />
              </Grid>

              <Grid item xs={12} className={classes.colorLabelRoot}>
                <Typography variant="body1" component="span" className={classes.colorLabel}>
                  Smart Bubble Text:
                </Typography>
                <ColorPicker value={values.bubbleText} onChange={color => this.handleInput("bubbleText", color)} />
              </Grid>

              <Grid item xs={12} className={classes.colorLabelRoot}>
                <Typography variant="body1" component="span" className={classes.colorLabel}>
                  User Message:
                </Typography>
                <ColorPicker value={values.userMessage} onChange={color => this.handleInput("userMessage", color)} />
              </Grid>

              <Grid item xs={12} className={classes.colorLabelRoot}>
                <Typography variant="body1" component="span" className={classes.colorLabel}>
                  User Message Text:
                </Typography>
                <ColorPicker
                  value={values.userMessageText}
                  onChange={color => this.handleInput("userMessageText", color)}
                />
              </Grid>

              <Grid item xs={12} className={classes.colorLabelRoot}>
                <Typography variant="body1" component="span" className={classes.colorLabel}>
                  Assistant Message:
                </Typography>
                <ColorPicker value={values.botMessage} onChange={color => this.handleInput("botMessage", color)} />
              </Grid>

              <Grid item xs={12} className={classes.colorLabelRoot}>
                <Typography variant="body1" component="span" className={classes.colorLabel}>
                  Assistant Message Text:
                </Typography>
                <ColorPicker
                  value={values.botMessageText}
                  onChange={color => this.handleInput("botMessageText", color)}
                />
              </Grid>
              <Grid item xs={12}>
                {isLoading ? (
                  <CircularProgress className={classes.progress} />
                ) : (
                  <Button
                    className={classes.saveButton}
                    color="primary"
                    disabled={!changed}
                    size="large"
                    variant="contained"
                    type="submit"
                  >
                    Save Color Settings
                  </Button>
                )}
              </Grid>
            </Grid>
          </form>
          <Iframe source={botUrlClosed} small={true} />
          <Iframe source={botUrlOpened} small={false} />
        </Paper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator"
});

ColorForm = connect(mapStateToProps, { pushMessage, updateChatbotColorSettings })(ColorForm);

export default withStyles(styles)(ColorForm);
